/* ActionsRenderer.js */

"use strict";

//const _ = require("lodash");

class ActionsRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("actions-column");
        this._rootElem.component = this._model;

        this._registerListeners();
        this.render();
    }
    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _shutdown() {
        let prom = new Promise((resolve /*,reject*/) => {
            this._unregisterListeners();
            this._model = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;
            resolve();
        });
        return prom;
    }
    _registerListeners() {
        this._model.on("Actions", (this._onActions = this._onActions.bind(this)));
        this._rootElem.addEventListener("click", (this._onClick = this._onClick.bind(this)));
    }
    _unregisterListeners() {
        this._model.removeAllListeners("Actions");
        this._rootElem.removeEventListener("click", this._onClick);
    }
    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        let prom = new Promise((resolve /*,reject*/) => {
            this._setActions(this._model.getValue());
            resolve();
        });
        return prom;
    }
    get rootElement() {
        return this.getRootElement();
    }
    getRootElement() {
        return this._rootElem;
    }
    get model() {
        return this.getModel();
    }
    getModel() {
        return this._model;
    }
    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    _onActions(newVal) {
        this._setActions(newVal);
    }

    _onClick(evt) {
        const el = evt.target;
        const spanEl = el.closest("span");
        const cls = spanEl.className.replace("action-item ", "");
        this._model._parentModel.emit("GridAction", { action: cls, entity: this._model.getValue() });
    }

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/

    _setActions(/*newVal*/) {
        const htmlString = `
            <span class="action-item policy"><actionable-icon-gl title="Policy" data-icon='configdrift.audit_policy'></actionable-icon-gl></span>
            <span class="action-item violations"><actionable-icon-gl title="Results" data-icon='common.results_link'></actionable-icon-gl></span>
            <span class="action-item run"><actionable-icon-gl title="Run Audit" data-icon='configdrift.run_audit2'></actionable-icon-gl></span>
            <span class="action-item hide"><actionable-icon-gl title="Hide" data-icon='common.hide'></actionable-icon-gl></span>
        `;
        this._rootElem.innerHTML = htmlString;
    }

    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}

module.exports = ActionsRenderer;
